import {
  post,
  put,
  get
} from '../configApi'
// user general
export async function getUserList(params) {
  return await get(`/account/list/user`, params)
}
export async function getUserEditByID(idstudent) {
  return await get(`/account/manage/detail/student`, idstudent)
}
export async function register(body) {
  return await post(`/account/tula/register/admin`, body)
}
export async function registerSendMail(body) {
  return await post(`/sendmail/register`, body)
}
export async function updateUser(body) {
  return await put(`/account/manage/update/student`, body)
}
export async function preview(body) {
  return await post(`/account/tula/register/preview`, body)
}
export async function importStudent(body) {
  // return await post(`/account/tula/register/import/student`, body)
  return await post(`/account/tula/register/importv2/student`, body)
}
export async function moveUserToBin(body) {
  return await post(`/account/manage/trash`, body)
}
export async function getUserListBin(params) {
  return await get(`/account/list/trash`, params)
}
export async function getUserActiveCalendar(params) {
  return await get(`/report/student/courseschedule`, params)
}

// user group
export async function getUserGroup(params) {
  return await get(`/usergroup/list`, params)
}
export async function addUserGroup(body) {
  return await put(`/account/manage/usergroup/student`, body)
}
export async function getUserGroupForDelete(params) {
  return await get(`/account/list/studentfordelete`, params)
}
export async function putActiveAll(body) {
  return await post(`/account/manage/activeall`, body)
}
export async function putActiveAllGroup(body) {
  return await post(`/account/manage/activeallgroup`, body)
}
export async function postMoveUserToNewGroup(body) {
  return await post(`/account/manage/movegroupuser`, body)
}
export async function deleteUserAllGroup(body) {
  return await post(`/account/manage/deletealltrashgroup`, body)
}

// user active
export async function updateActive(body) {
  return await put(`/account/manage/active/student`, body)
}

// user teacher
export async function getUserTeacherList(params) {
  return await get(`/account/list/teacher`, params)
}
export async function verifyUserTeacher(body) {
  return await put(`/account/manage/activeverify`, body)
}
export async function editProfile(body) {
  return await put(`/account/manage/update/editprofile`, body)
}
export async function updatePassword(body) {
  return await put(`/account/manage/update/editpassword`, body)
}

export async function verifyTeacher(body) {
  return await put(`/account/manage/verifyteacher`, body)
}

export async function editProfileByID(body) {
  return await put(`/account/tula/register/import/editprofilebyid`, body)
}

// report
export async function exportReport(body) {
  return await get(`/account/profile/report`, body)
}

